export const mapInvoice = (invoice: any) => ({
  id: invoice.invoiceId ?? "",
  userId: invoice.userId ?? "",
  adminUserId: invoice.adminUserId ?? null,
  documentUrl: invoice.documentUrl ?? null,
  documentOwner: invoice.documentOwner ?? "",
  type: invoice.type ?? "",
  invoiceDate: invoice.invoiceDate ?? "",
  supplier: invoice.supplier ?? "",
  extractedPoNumber: invoice.extractedPoNumber ?? "",
  documentReference: invoice.documentReference ?? "",
  dueDate: invoice.dueDate ?? "",
  discountAmount: invoice.discountAmount ?? null,
  category: invoice.category?.trim?.() ?? "",
  productOrService: invoice.productOrService?.trim?.() ?? "",
  user: invoice.customer ?? "",
  markAsRebillable: invoice.markAsRebillable ?? "",
  description: invoice.description ?? "",
  amount: invoice.amount ?? 0,
  currency: invoice.currency ?? "",
  totalAmount: invoice.totalAmount ?? 0,
  taxAmount: invoice.taxAmount ?? 0,
  netAmount: invoice.netAmount ?? 0,
  payment: invoice.payment ?? 0,
  paid: invoice.paid ?? 0,
  paymentMethod: invoice.paymentMethod ?? "",
  submittedBy: invoice.submittedByName ?? invoice.SubmittedByName ?? invoice.submittedBy ?? invoice.SubmittedBy ?? invoice.submitterName,
  lineItems: Array.isArray(invoice.lineItems) ? invoice.lineItems : [],
  stageId: invoice.stageId ?? 0,
  isActive: invoice.isActive ?? true,
  isDelete: invoice.isDelete ?? false,
  archiveStatus: invoice.archiveStatus ?? "UnArchived",
  isFlagged: invoice.isFlagged ?? false, 
  supplierId: invoice.supplierId ?? invoice.SupplierId ?? null,
  categoryId: invoice.categoryId ?? invoice.CategoryId ?? null,
   createdDate: invoice.createdDate ?? "", 
   mergeStatus: invoice.mergeStatus ?? null,
   documentShortId: invoice.documentShortId ?? "",
   isDuplicate: invoice.isDuplicate ,
});

export const mapSingleInvoice = (invoice: any) => ({
  archiveStatus: invoice.ArchiveStatus ,
  invoiceId: invoice.InvoiceId ?? 0,
  userId: invoice.UserId ?? "",
  adminUserId: invoice.AdminUserId ?? null,
  documentUrl: invoice.DocumentUrl ?? "",
  documentOwner: invoice.DocumentOwner?.trim?.() ?? "",
  type: invoice.Type?.trim?.() ?? "",
  invoiceDate: invoice?.InvoiceDate?.split("T")[0] ?? "",
  supplier: invoice.Supplier?.trim?.() ?? "",
  extractedPoNumber: invoice.ExtractedPoNumber?.trim?.() ?? "",
  documentReference: invoice.DocumentReference?.trim?.() ?? "",
  dueDate: invoice.DueDate?.split("T")[0] ?? null,
  category: invoice.Category?.trim?.() ?? "",
  productOrService: invoice.ProductOrService?.trim?.() ?? "",
  customer: invoice.Customer ?? "",
  markAsRebillable: invoice.MarkAsRebillable?.trim?.() ?? "",
  description: invoice.Description?.trim?.() ?? "",
  amount: invoice.Amount ?? 0,
  currency: invoice.Currency?.trim?.() ?? "",
  discountAmount: invoice.DiscountAmount ?? 0,
  totalAmount: invoice.TotalAmount ?? 0,
  taxAmount: invoice.TaxAmount ?? 0,
  netAmount: invoice.NetAmount ?? 0,
  payment: invoice.Payment ?? 0,
  paid: invoice.Paid?.trim?.() ?? "",
  paymentMethod: invoice.PaymentMethod?.trim?.() ?? "",
  submissionMethod: invoice.SubmissionMethod ?? invoice.submissionMethod ?? "",
  submittedBy: invoice.SubmittedByName ?? invoice.submittedByName ?? invoice.SubmittedBy ?? invoice.submittedBy ?? invoice.SubmitterName,
  lineItems: Array.isArray(invoice.lineItems) ? invoice.lineItems : [],
  stageId: invoice.StageId ?? 0,
  isActive: invoice.IsActive ?? true,
  isDelete: invoice.IsDelete ?? false,
  isFlagged: invoice.isFlagged ?? false,
  supplierId: invoice.SupplierId ?? invoice.supplierId ?? null,
  categoryId: invoice.CategoryId ?? invoice.categoryId ?? null,
  isDuplicate: invoice.IsDuplicate ,
  duplicateFlagId: invoice.DuplicateFlagId ,
  mergeStatus: invoice.MergeStatus ?? null,
  mergeParentId: invoice.MergeParentId ?? null,
});

export const mapToUpdateInvoicePayload = (invoiceData: any) => ({
  InvoiceId: invoiceData.invoiceId,
  UserId: invoiceData.userId,
  AdminUserId: invoiceData.adminUserId,
  DocumentUrl: invoiceData.documentUrl,
  DocumentOwner: invoiceData.documentOwner,
  Type: invoiceData.type,
  InvoiceDate: invoiceData.invoiceDate,
  Supplier: invoiceData.supplier,
  ExtractedPoNumber: invoiceData.extractedPoNumber,
  DocumentReference: invoiceData.documentReference,
  DueDate: invoiceData.dueDate,
  Category: invoiceData.category,
  ProductOrService: invoiceData.productOrService,
  Customer: invoiceData.customer,
  MarkAsRebillable: invoiceData.markAsRebillable,
  Description: invoiceData.description,
  Amount: invoiceData.amount,
  Currency: invoiceData.currency,
  DiscountAmount: invoiceData.discountAmount,
  TotalAmount: invoiceData.totalAmount,
  TaxAmount: invoiceData.taxAmount,
  NetAmount: invoiceData.netAmount,
  Payment: invoiceData.payment,
  Paid: invoiceData.paid,
  PaymentMethod: invoiceData.paymentMethod,
  LineItems: invoiceData.lineItems,
  StageId: invoiceData.stageId,
  IsActive: invoiceData.isActive,
  IsDelete: invoiceData.isDelete,
  SupplierId: invoiceData.supplierId ?? invoiceData.SupplierId ?? null,
  CategoryId: invoiceData.categoryId ?? invoiceData.CategoryId ?? null,
});